module.exports = __webpack_public_path__ + "static/img/xmzz62.bbdc298.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xmzz62.png
// module id = gd5d
// module chunks = 73